const { SINGLE_ACTION_DISPATCHED } = require("./actionTypes")

const initialState = {
  dispatched_actions: []
}

const SingleActionDispatch = (state = initialState, action) => {
  switch (action.type) {
    case SINGLE_ACTION_DISPATCHED:
      return {
        ...state,
        dispatched_actions: [...state.dispatched_actions, action.payload]
      }
    default:
      return state
  }
}

export default SingleActionDispatch;